import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Rooms.css';

import combo from '../assets/imgs/rooms-combo-2.png';

class Combo extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-title">COMBO</div>
                        <div style={{ display: "inline" }}>
                            <img src={combo} alt="" />
                        </div>
                        <div>
                            <p style={{ color: "white" }}>Minimum 4 players required for the combos.</p>
                        </div>
                        <div className="Room-description">
                            <div className="table-container">
                                <div className="table-row">
                                    <div className="table-label">MISSION</div>
                                    <div className="table-text">
                                        Play any of our 4 chapters as a combo experience. 
                                    </div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">PLAYERS</div>
                                    <div className="table-text">Min 4, Max 8</div>
                                </div>
                            </div>
                            <div>
                                <table style={{ width:"66%"}}>
                                    <tbody>
                                        <tr>
                                            <td colSpan={"3"}><b>2 game combo</b><br></br> (100 min experience)</td>
                                        </tr>
                                        <tr>
                                            <td>People</td>
                                            <td>Ticket Prices</td>
                                            <td>Total</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>$86/person</td>
                                            <td>$344</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>$82/person</td>
                                            <td>$410</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>$78/person</td>
                                            <td>$468</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>$75/person</td>
                                            <td>$525</td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>$72/person</td>
                                            <td>$576</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <table style={{ width:"66%"}}>
                                    <tbody>
                                        <tr>
                                            <td colSpan={"3"}><b>3 game combo</b><br></br> (2 1/2hr experience)</td>
                                        </tr>
                                        <tr>
                                            <td>People</td>
                                            <td>Ticket Prices</td>
                                            <td>Total</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>$125/person</td>
                                            <td>$500</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>$120/person</td>
                                            <td>$600</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>$115/person</td>
                                            <td>$690</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>$110/person</td>
                                            <td>$770</td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>$105/person</td>
                                            <td>$840</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br></br>
                            </div>
                            <div>
                                <table style={{ width:"66%"}}>
                                    <tbody>
                                        <tr>
                                            <td colSpan={"3"}><b>4 game combo</b><br></br> (3 hr 20 min experience)</td>
                                        </tr>
                                        <tr>
                                            <td>People</td>
                                            <td>Ticket Prices</td>
                                            <td>Total</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>$160/person</td>
                                            <td>$640</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>$155/person</td>
                                            <td>$775</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>$150/person</td>
                                            <td>$900</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>$145/person</td>
                                            <td>$1,015</td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>$140/person</td>
                                            <td>$1,120</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br></br>
                            </div>
                            <div className="note">
                                * If you desire to book a specific game that is not reflected on our
                                Ticket Schedule please contact us for further availability. <br />*
                                You can swap Chapters. If for a desired time slot you would prefer
                                to do another Chapter
                                <br /> that is originally offered on our Ticketing Site, please
                                contact us to swap for your preferred Chapter.
                            </div>
                        </div>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Combo;
